import core from '@/helpers/client'

const jdaCategoryService = {
  async headJDACategoryAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories`,
      params
    )
    return result
  },
  async getJDACategoryListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories`,
      params
    )
    return result
  },
  async getJDACategoryTreeNodeAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/treenode`,
      params
    )
    return result
  },
  async getMappingJDACategoryTreeNodeAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/mappingtreenode`,
      params
    )
    return result
  },
  async getJDACategoryDetailAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/${id}`,
      params
    )
    return result
  },
  async getJDACategoryByIdsAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/manysearch`,
      params
    )
    return result
  },
  async getJDAProductSkuListAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/${id}/skus`
    )
    return result
  },
  async createJDACategoryAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories`,
      model
    )
    return result
  },
  async updateJDACategoryAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/${id}`,
      model
    )
    return result
  },
  async updateAllJDACategoryApprovalAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/${id}/approval`,
      model
    )
    return result
  },
  async deleteJDACategoryByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/JDACategories/delete/${id}`
    )
    return result
  },
}
export default jdaCategoryService
